<template>
  <div>
    <el-card class="">
      <div slot="header" class="clearfix flex justify-between">
        <span>{{ $t('integralSetting.title') }}</span>
        <el-button style="float: right; padding: 3px 0" type="text" @click="showMarkdown">
          {{ $t('common.document') }}
        </el-button>
      </div>

      <el-table :data="integralSettingInfo.integralSettings" style="width: 100%" border>
        <el-table-column prop="settingId" :label="$t('integralSetting.id')" align="center" width="120" />
        <el-table-column :label="$t('integralSetting.money')" align="center">
          <template slot-scope="scope">
            {{ $t('integralSetting.onePointEquals') }}{{ scope.row.money }}{{ $t('integralSetting.yuan') }}
          </template>
        </el-table-column>
        <el-table-column prop="remark" :label="$t('integralSetting.usage')" align="center" />
        <el-table-column :label="$t('integralSetting.shopping')" align="center" width="120">
          <template slot-scope="scope">
            {{ scope.row.goodsFlag === 'Y' ? $t('common.yes') : $t('common.no') }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('integralSetting.payment')" align="center" width="120">
          <template slot-scope="scope">
            {{ scope.row.feeFlag === 'Y' ? $t('common.yes') : $t('common.no') }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('common.operation')" align="center" width="150">
          <template slot-scope="scope">
            <el-button size="mini" @click="openEditIntegralSettingModel(scope.row)">
              {{ $t('common.edit') }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination :current-page="pagination.currentPage" :page-size="pagination.pageSize" :total="pagination.total"
        layout="total, prev, pager, next" @current-change="handlePageChange" />
    </el-card>

    <edit-integral-setting ref="editIntegralSetting" @refresh="listIntegralSettings" />
  </div>
</template>

<script>
import { listIntegralSetting } from '@/api/admin/integralSetting/integralSettingApi'
import EditIntegralSetting from '@/components/admin/editIntegralSetting/editIntegralSetting'

export default {
  name: 'IntegralSetting',
  components: {
    EditIntegralSetting
  },
  data() {
    return {
      integralSettingInfo: {
        integralSettings: [],
        conditions: {
          money: '',
          remark: '',
          thirdFlag: ''
        }
      },
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  created() {
    this.listIntegralSettings()
  },
  methods: {
    async listIntegralSettings(page = 1, rows = 10) {
      this.pagination.currentPage = page
      const params = {
        ...this.integralSettingInfo.conditions,
        page,
        row: rows
      }

      try {
        const res = await listIntegralSetting(params)
        this.integralSettingInfo.integralSettings = res.data
        this.pagination.total = res.records
      } catch (error) {
        console.error('获取积分设置列表失败:', error)
      }
    },
    openEditIntegralSettingModel(row) {
      this.$refs.editIntegralSetting.open(row)
    },
    handlePageChange(currentPage) {
      this.listIntegralSettings(currentPage)
    },
    showMarkdown() {
      console.log('showMarkdown')
    }
  }
}
</script>

<style scoped>
.box-card {
  margin: 20px;
}
</style>